import React from "react";
import { useRouter } from "next/router";
import { ArticlesHero } from "@ecologi/react-components/src/ArticlesHero";
import { BlogMorePosts } from "@ecologi/react-components/src/BlogMorePosts";
import { SocialShare } from "@ecologi/react-components/src/SocialShare";
import { WidgetPage } from "../../../../widgets";
import { getClientUrl, getWPData, REBUILD_TIMEOUT } from "../../../../lib";
import { Wordpress } from "@ecologi/shared";
import logger from "../../../../lib/logger";

const NUMBER_OF_RECOMMENDED_POSTS = 3;

export default function Page(props) {
  const title = props.data.title.rendered;
  const router = useRouter();
  const currentUrl = getClientUrl(router.asPath);

  return (
    <>
      <WidgetPage
        header={<ArticlesHero {...props} title={title} />}
        {...props}
        footer={<BlogMorePosts posts={props.posts} />}
      />
      <SocialShare
        twitterShareText="Checkout this article from Ecologi"
        shareLink={currentUrl}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const data = await getWPData(`posts?slug=${params.slug}&_embed`, true);

  if (!data) {
    return {
      notFound: true,
    };
  }

  const posts = await getWPData(
    `posts?per_page=${NUMBER_OF_RECOMMENDED_POSTS}&_embed&exclude=${data.id}`
  );

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data,
      posts: posts || [],
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: false,
      },
    },
  };
}

export type WPCategory = {
  id: number;
  count: number;
  description: string;
  link: string;
  name: string;
  slug: string;
  taxonomy: string;
  parent: number;
  meta: any[];
  acf: any[];
  _links: object;
};

export async function getStaticPaths() {
  let data = [];
  let pageNumber = 1;

  while (true) {
    const res = await getWPData(
      `posts?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&page=${pageNumber}&_fields=slug,categories`
    );

    if (!Array.isArray(res) || res.length === 0) break;

    data = [...res, ...data];
    pageNumber++;

    logger.info(
      `Waiting on page ${pageNumber} for 'articles/[category]/[slug]'...`
    );
    await new Promise((res) => setTimeout(res, 2e3)); // don't DOS the site
  }

  const allCategories: WPCategory[] = await getWPData(
    `categories?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&_fields=id,slug`
  );

  return {
    paths:
      data.map(({ slug, categories: articleCategories }) => {
        const category = allCategories.find(
          ({ id }) => articleCategories[0] === id
        );

        return `/articles/${category.slug}/${slug}`;
      }) || [],
    fallback: "blocking",
  };
}
